import { createCipheriv, createDecipheriv } from 'crypto';
import { Buffer } from 'buffer';

var INPUT_ENCODING = 'utf8';
var OUTPUT_ENCODING = 'base64';
var ALGORITHM = 'aes256';

var key = checkKey(process.env.PUBLIC_KEY, 32);
var iv = checkKey(process.env.SECRET_KEY);

function checkKey(_key) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;

    var keyBuffer = new Buffer(_key, INPUT_ENCODING);
    var targetBuffer = new Buffer(length);
    keyBuffer.copy(targetBuffer, 0, 0, Math.min(keyBuffer.length, targetBuffer.length));

    return targetBuffer;
}

export var encryptText = function encryptText(text) {
    var cipher = createCipheriv(ALGORITHM, key, iv);
    return cipher.update(text, INPUT_ENCODING, OUTPUT_ENCODING) + cipher.final(OUTPUT_ENCODING);
};

export var decryptText = function decryptText(text) {
    var decipher = createDecipheriv(ALGORITHM, key, iv);
    return decipher.update(text, OUTPUT_ENCODING, INPUT_ENCODING) + decipher.final(INPUT_ENCODING);
};


//////////////////
// WEBPACK FOOTER
// ./src/plugins/crypto.js
// module id = ./src/plugins/crypto.js
// module chunks = 34